var YouTubeVideo = require('./YouTubeVideo');

module.exports = YouTubeVideo;
